import { useResetAtom } from 'jotai/utils';

import { deviceDetailsAtom, deviceTypeAtom } from '../atoms';
import { useCustomerDetailsConfirmedAtom } from './useCustomerDetailsConfirmedAtom';

export const useResetDeviceAndDamageState = () => {
  const resetDeviceTypeIdState = useResetAtom(deviceTypeAtom);
  const resetDeviceDetailsState = useResetAtom(deviceDetailsAtom);
  const [, setCustomerDetailsConfirmed] = useCustomerDetailsConfirmedAtom();

  const resetDeviceAndDamageState = () => {
    resetDeviceTypeIdState();
    resetDeviceDetailsState();
    setCustomerDetailsConfirmed(false);
  };

  return { resetDeviceAndDamageState };
};
